"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgLogosuportev3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_suporte_v3_svg__Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 70,
    viewBox: "0 0 43 43",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", null, ".logo_suporte_v3_svg__st0,.logo_suporte_v3_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0a6fb8}.logo_suporte_v3_svg__st1{fill:#fff}.logo_suporte_v3_svg__st2{fill:none;stroke:#0a6fb8;stroke-width:.5;stroke-linejoin:round;stroke-miterlimit:10}"), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st0",
    d: "M.5 21.5c0-11.6 9.4-21 21-21 5.6 0 10.9 2.2 14.8 6.2s6.2 9.3 6.2 14.8c0 11.6-9.4 21-21 21s-21-9.4-21-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M10.2 21.3c0-6.2 5.1-11.3 11.5-11.3 3.1 0 6 1.2 8.1 3.3 2.2 2.1 3.4 5 3.4 7.9 0 6.2-5.1 11.3-11.5 11.3s-11.5-5-11.5-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M14.4 32.2c0-.2.8-.4 2.2-.7 1.4-.2 3.2-.2 5.2-.2 4 0 7.3.4 7.3.9 0 .4-3.3.9-7.3.9-4.1 0-7.4-.3-7.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st0",
    d: "M18.9 24.1h5.6c.7 0 1.3.2 1.8.8.5.4.7 1.1.7 1.8v2.6H16.3v-2.6c0-1.5 1.2-2.6 2.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M18.9 24.1h5.6c.7 0 1.3.2 1.8.8.5.4.7 1.1.7 1.8v2.6H16.3v-2.6c0-1.5 1.2-2.6 2.6-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M28.8 25.9l-1.4 5.7H15.8l-1.4-5.7h14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M28.8 25.9l-1.4 5.7H15.8l-1.4-5.7h14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M21 28.8c0-.4.3-.9.8-.9.2 0 .4.1.6.2.2.1.2.3.2.5 0 .4-.3.9-.8.9-.5.1-.8-.2-.8-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M21 28.8c0-.4.3-.9.8-.9.2 0 .4.1.6.2.2.1.2.3.2.5 0 .4-.3.9-.8.9-.5.1-.8-.2-.8-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M15.2 32.1c0-.2.1-.3.3-.3H28c.1 0 .2 0 .2.1.1 0 .1.1.1.2 0 .2-.1.3-.3.3H15.5c-.2.1-.3-.2-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M15.2 32.1c0-.2.1-.3.3-.3H28c.1 0 .2 0 .2.1.1 0 .1.1.1.2 0 .2-.1.3-.3.3H15.5c-.2.1-.3-.2-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M25.2 24c0 .4-1.5.7-3.4.7s-3.4-.3-3.4-.7c2.2.2 4.7.2 6.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 24h0c0 .4-1.5.7-3.4.7s-3.4-.3-3.4-.7h0c2.2.2 4.7.2 6.8 0z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st0",
    d: "M15.6 18.8c0-2.9 2.3-5.2 5.1-5.2h2.2c1.4 0 2.7.5 3.6 1.5s1.5 2.3 1.5 3.7c0 2.9-2.3 5.2-5.1 5.2h-2.2c-2.8.1-5.1-2.3-5.1-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M15.6 18.8c0-2.9 2.3-5.2 5.1-5.2h2.2c1.4 0 2.7.5 3.6 1.5s1.5 2.3 1.5 3.7c0 2.9-2.3 5.2-5.1 5.2h-2.2c-2.8.1-5.1-2.3-5.1-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M14.5 20.1v-2.3c0-.1 0-.2.1-.3.1-.1.2-.1.4-.1h.5v3.4H15c-.2-.3-.5-.5-.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M14.5 20.1v-2.3c0-.1 0-.2.1-.3.1-.1.2-.1.4-.1h.5v3.4H15c-.2-.3-.5-.5-.5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M29.1 17.7V20c0 .1 0 .2-.1.3-.1.1-.2.1-.4.1h-.5V17h.5c.3.2.5.5.5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M29.1 17.7V20c0 .1 0 .2-.1.3-.1.1-.2.1-.4.1h-.5V17h.5c.3.2.5.5.5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8 13.7v-1.4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M21.8 13.7v-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st1",
    d: "M16.5 17.8c0-1.1.8-2 1.9-2h6.9c.5 0 1 .2 1.3.5.4.3.6.9.6 1.3v2.2c0 1.1-.8 2-1.9 2h-6.9c-1 0-1.9-.9-1.9-2v-2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st0",
    d: "M17 18.7c0-.8.4-1.3 1-1.3.3 0 .5.1.7.4.2.3.3.5.3 1 0 .8-.4 1.3-1 1.3-.6-.1-1-.8-1-1.4z",
    id: "logo_suporte_v3_svg__g1f7d2a81252_0_0_1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st0",
    d: "M22.6 20.3c0 .3-.1.5-.4.8s-.6.2-.9 0c-.3-.1-.5-.4-.5-.8h1.8zM21.2 11.7c0-.3.3-.7.6-.7.1 0 .3.1.4.2.1.1.2.2.2.4 0 .3-.3.7-.6.7-.4-.1-.6-.3-.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st2",
    d: "M21.2 11.7c0-.3.3-.7.6-.7.1 0 .3.1.4.2.1.1.2.2.2.4 0 .3-.3.7-.6.7-.4-.1-.6-.3-.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_suporte_v3_svg__st0",
    d: "M22.5 18.7c0-.8.4-1.3 1-1.3.3 0 .5.1.7.4.2.2.3.5.3 1 0 .8-.4 1.3-1 1.3-.5-.1-1-.7-1-1.4z"
  }));
}
var _default = exports["default"] = SvgLogosuportev3;